<template>
  <transition name="fade" appear>
    <section>
      <div>
        <p style="text-align: center; margin: 0">
          <img src="@/assets/logos/lions-loyal.png" alt="" width="75" />
        </p>
        <PageTitles
          h1="LEARN MORE ABOUT"
          h2="THE LIONS LOYAL MEMBERSHIP WAITLIST"
        />
      </div>
      <div class="new-benefits">
        <h3>
          <img src="@/assets/icons/new-benefits.svg" alt="" />
          <span class="blue">Join Today!</span>
        </h3>
      </div>
      <div class="ui">
        <div class="gameday">
          <h2><span>Details</span></h2>
          <div class="event-ticket" v-for="(item, id) in details">
            <div class="info">
              <div class="icon">
                <img :src="item.icon" alt="" />
              </div>
              <div class="game">
                <p class="title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="non-gameday">
          <h2><span>Benefits</span></h2>
          <div class="event-ticket" v-for="(item, id) in benefits">
            <div class="info">
              <div class="icon">
                <img :src="item.icon" alt="" />
              </div>
              <div class="game">
                <p class="title">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <router-link
          class="place-deposit"
          :to="{
            name: 'Faq',
          }"
          >Frequently Asked Questions</router-link
        >
        <a
          class="place-deposit"
          href="https://www.detroitlions.com/tickets/season-tickets/"
          target="_blank"
          >PLACE YOUR DEPOSIT NOW</a
        >
      </div>
    </section>
  </transition>
</template>
<script setup>
import PageTitles from "@/components/PageTitles";

const details = [
  {
    title: "$100 Per Ticket (Maximum 4 Tickets Per Account)",
    icon: require("@/assets/icons/wishlist/icon-detail-deposits.png"),
  },
  {
    title: "All deposits are time stamped and dated",
    icon: require("@/assets/icons/wishlist/icon-detail-deposit-time-stamp.png"),
  },
  {
    title: "Will Be Applied To An Eventual Season Ticket Purchase",
    icon: require("@/assets/icons/wishlist/icon-detail-ticket.png"),
  },
  {
    title: "Deposits Are Non-Refunable And Non-Transferable",
    icon: require("@/assets/icons/wishlist/icon-detail-non-transfer.png"),
  },
];
const benefits = [
  {
    title: "Priority access to seating locations",
    icon: require("@/assets/icons/wishlist/icon-benefits-priority.png"),
  },
  {
    title: "Access to single game presales (based on availability)",
    icon: require("@/assets/icons/wishlist/icon-benefits-acess-single.png"),
  },
  {
    title: "Access to concert presales (based on availability)",
    icon: require("@/assets/icons/wishlist/icon-benefits-concerts.png"),
  },
];
</script>
<style lang="scss" scoped>
.event-ticket {
  background-color: #fff;
  user-select: none;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  transition: all 0.5s;

  @media (hover: hover) {
    &:hover {
      transform: translateX(10px);
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.2);
      background-color: #00456a;
      * {
        color: white;
      }
      .info:before {
        // background-image: none;
      }
    }
  }
  .info {
    display: flex;
    position: relative;
    overflow: hidden;
    gap: 8px;
    flex-grow: 1;
    height: 67px;
    align-items: stretch;
    @media (max-width: 900px) {
      height: 80px;
    }
    @media (min-width: 400px) {
      gap: 10px;
    }

    &:before {
      content: "";
      background-image: url("~@/assets/images/grunge.png");
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.1;
      pointer-events: none;
    }
    > div {
      box-sizing: border-box;
      display: flex;
    }
    .icon {
      z-index: 1;
      width: 76px;
      flex-shrink: 0;
      align-items: center;
      border-radius: 0px 10px;
      background: linear-gradient(90deg, #ffffff 0%, #ccc 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
      }
    }
    .game {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      padding: 0;

      flex-grow: 1;
    }
    p {
      margin: 0;
      padding: 0 10px;
      font-family: "United Sans Cd Bd";
      font-weight: bold;
      font-size: 1.5rem;
      line-height: 1;
      text-transform: uppercase;
    }
  }
}
.new-benefits {
  border-bottom: 1px solid #ffffff;
  display: block;
  align-items: center;
  margin-left: 0px;
  width: 100%;
  max-width: 1150px;
  @media (min-width: 800px) {
    display: flex;
    align-items: flex-end;
  }
  p {
    font-family: "United Sans SmCd";
    font-weight: 500;
    font-size: 1.375rem;
    color: #fff;
    span {
      font-family: "United Sans SmCd Hv";
      font-weight: 900;
    }
  }
  h3 {
    position: relative;
    left: -11px;
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    font-size: 1.5rem;
    line-height: 1;
    text-transform: uppercase;
    color: #54585a;
    background: url("~@/assets/shapes/shape-new loyal-benefit.svg") no-repeat;
    background-size: contain;
    min-width: 350px;
    min-height: 53px;
    display: flex;
    display: block;
    align-items: center;
    gap: 15px;
    padding: 15px 25px;
    padding-bottom: 0;
    img,
    span {
      vertical-align: middle;
    }
    img {
      margin-right: 10px;
    }
    .blue {
      color: #0076b6;
    }
  }
}
h2 {
  position: relative;
  img {
    margin-right: 15px;
  }
  span {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    font-size: 1.5rem;
    line-height: 1;
    text-transform: uppercase;
    color: #0076b6;
    background: url("~@/assets/shapes/special-event-white-shape.svg") no-repeat;
    height: 60px;
    background-size: cover;
    display: flex;
    align-items: center;
    padding-left: 32px;
    margin-bottom: 30px;
    position: relative;
  }
  &:before {
    content: "";
    background: url("~@/assets/shapes/special-event-grey-shape.svg") no-repeat
      center center;
    background-size: contain;
    position: absolute;
    right: 0;
    top: 14px;
    width: 328px;
    height: 56px;
  }
}
section {
  display: flex;
  flex-direction: column;
  gap: 50px;
  align-items: center;
}
.buttons {
  display: flex;
  gap: 20px;
  margin-top: 40px;
  justify-content: center;
  align-items: center;
  @media (max-width: 800px) {
    flex-direction: column;
  }
  .place-deposit {
    font-family: "United Sans Cd Hv";
    font-weight: 900;
    border: 2px solid #fff;
    padding: 10px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #0076b6;
    background-color: #fff;
    font-size: 1.125rem;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 225px;
    gap: 8px;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
    width: 250px;
  }
}

.ui {
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  gap: 40px;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  // :deep() {
  //   .event-ticket .info .game {
  //     height: 72px;
  //   }
  // }
  @media (min-width: 800px) {
    flex-direction: row;
    > * {
      width: 50%;
    }
  }
}
</style>
